import React from 'react'
import { Grid, Radio } from 'semantic-ui-react'
import InputField from '../formComponents/inputField'
import { ImportShipment } from '../../containers/importShipment'
import { useDispatch, useSelector } from 'react-redux'
import { saveValueBuildUpField, updateValueBuildUp } from './actions/ValueBuildUp'

const DefaultValues = ({ translate }) => {
  const valbuilupFormData = useSelector((state) => state.ValueBuildUpReducer) || {}
  const dispatch = useDispatch()
  return (
    <div className='defaultValues'>
      <span>{translate('DEFAULT_VALUES', { ns: ['default', 'valueBuildUp'] })}</span>
      <Grid className='kn__grid'>
        <ImportShipment>
          <Grid.Row>
            <Grid.Column width='6' className='divFormFeild'>
              <InputField
                isLabel={false}
                id='upliftPercentage'
                type='text'
                label={translate('UPLIFT_PERCENTAGE', { ns: ['default', 'valueBuildUp'] })}
                className={'field-bg'}
                clearInput={false}
                value={valbuilupFormData.upliftPercentage}
                onChange={(value) => {
                  dispatch(updateValueBuildUp({ upliftPercentage: value }))
                  dispatch(saveValueBuildUpField(['upliftPercentage']))
                }}
              />
            </Grid.Column>
            <Grid.Column width='10' className='divFormFeild'>
              <label
                for='floatField'
                title='UPLIFT PERCENTAGE'
                style={{ marginLeft: '3px', fontSize: '10px', display: 'block' }}
              >
                {translate('UPLIFT_INCLUDES_FREIGHT_CHARGES', {
                  ns: ['default', 'valueBuildUp'],
                }) + '?'}
              </label>
              <>
                <Radio
                  id='upliftFreightCharges-1'
                  label={translate('YES', { ns: ['default', 'valueBuildUp'] })}
                  name='upliftFreightCharges'
                  checked={valbuilupFormData.upliftIncludeFreightCharges === '1'}
                  value={'1'}
                  onChange={(e, data) => {
              
                    dispatch(updateValueBuildUp({ upliftIncludeFreightCharges: '1' }))
                    setTimeout(() => {
                      dispatch(saveValueBuildUpField(['upliftIncludeFreightCharges']))
                    }, 1000)
                  }}
                />
                <Radio
                  id='upliftFreightCharges-2'
                  label={translate('NO', { ns: ['default', 'valueBuildUp'] })}
                  name='upliftFreightCharges'
                  checked={valbuilupFormData.upliftIncludeFreightCharges === '0'}
                  value={'0'}
                  onClick={(e, data) => {
                    dispatch(updateValueBuildUp({ upliftIncludeFreightCharges: '0' }))
                    setTimeout(() => {
                      dispatch(saveValueBuildUpField(['upliftIncludeFreightCharges']))
                    }, 1000)
                  }}
                />
              </>
            </Grid.Column>
          </Grid.Row>
        </ImportShipment>
        <Grid.Row>
          <Grid.Column width='6' className='divFormFeild'>
            <InputField
              isLabel={false}
              id='insurancePercentage'
              type='text'
              label={translate('INSURANCE_PERCENTAGE', { ns: ['default', 'valueBuildUp'] })}
              className={'field-bg'}
              clearInput={false}
              value={valbuilupFormData.insurancePercentage}
              onChange={(value) => {
                dispatch(updateValueBuildUp({ insurancePercentage: value }))
                dispatch(saveValueBuildUpField(['insurancePercentage']))
              }}
            />
          </Grid.Column>
          <Grid.Column width='10' className='divFormFeild'>
            <label
              for='floatField'
              title='UPLIFT PERCENTAGE'
              style={{ marginLeft: '3px', fontSize: '10px', display: 'block' }}
            >
              {translate('INSURANCE_INCLUDES_FREIGHT_CHARGES', {
                ns: ['default', 'valueBuildUp'],
              }) + '?'}
            </label>
            <>
              <Radio
                id='insurancePercentage-1'
                label={translate('YES', { ns: ['default', 'valueBuildUp'] })}
                name='radioGroup'
                value={'1'}
                checked={valbuilupFormData.insuranceIncludesFreightCharges == '1'}
                onChange={(e, { value }) => {
                  dispatch(updateValueBuildUp({ insuranceIncludesFreightCharges: '1' }))
                  setTimeout(() => {
                    dispatch(saveValueBuildUpField(['insuranceIncludesFreightCharges']))
                  }, 1000)
                }}
              />
              <Radio
                id='insurancePercentage-2'
                label={translate('NO', { ns: ['default', 'valueBuildUp'] })}
                name='radioGroup'
                checked={valbuilupFormData.insuranceIncludesFreightCharges == '0'}
                value={'0'}
                onChange={(e, { value }) => {
                  dispatch(updateValueBuildUp({ insuranceIncludesFreightCharges: '0' }))
                  setTimeout(() => {
                    dispatch(saveValueBuildUpField(['insuranceIncludesFreightCharges']))
                  }, 1000)
                }}
              />
            </>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  )
}

export default React.memo(DefaultValues)
